import ImagemCarregando from "../../ImagemCarregando";
import perfil_image from "../../../../assets/perfil.png";
import capa_image from "../../../../assets/capa.png";
import { Card } from "../styled";
import { Content } from "./styled";
import { Link } from "react-router-dom";
import CircularImage from "../../CircularImage";

function CardGrupo({textButton, grupo, onClick, link, linkConhecer}){
  let usuarios = grupo?.grupos_usuarios;
  return (
    
    <Card className="card">
      <Content>
        
        <section>
          <div className="image">
            <ImagemCarregando src={grupo?.foto_capa?.path || capa_image} alt="Foto de capa do grupo"/>
          </div>
        </section>

        <section>
          <div className="description">
            <h4>{grupo?.nome}</h4>
            <div className="info">

              <div className="participantes">
                {
                  usuarios?.map(grupo_usuario=>{
                    return ( <CircularImage src={grupo_usuario.usuario?.foto_perfil?.path || perfil_image} alt={"Foto de perfil do participante"}/>)
                  })
                }
                <h6>{grupo?.quantidade_usuarios} participantes</h6>
              </div>

              {(link || onClick || linkConhecer) &&
                <div className="about">
                  <span>{grupo?.sobre}</span>
                </div>
              }
            </div>
          </div>
        </section>
        
        {(link || onClick || linkConhecer) &&
          <section>
            <div className="bottom">
              {
                // linkConhecer: pagina inteira do grupo (antes um modal). onClick segue
                // valendo para quem ainda usa o botao.
                linkConhecer ?
                  <Link to={linkConhecer}>{textButton || "Ver grupo"}</Link>
                : onClick ?
                  <button type="button" onClick={onClick}>{textButton || "Ver grupo"}</button>
                : <Link to={link.toString()}>{textButton || "Ver postagens"}</Link>
              }
              
            </div>
          </section>
        }
      </Content>
    </Card>    
  );
}

export default CardGrupo;

